import * as fetch from '../../../utils/action'
import { getTotalNumber } from '../totalMethod'
import informationData from '../datas/information'
export default {
  getNewsList (ctx, data) {
    return fetch.getNewsList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = informationData.getNewsList(result.data)
      return result
    })
  },
  newCategories (ctx) {
    return fetch.newCategories().then(res => {
      return res.data
    })
  },
  editNewsCategories (ctx, data) {
    return fetch.editNewsCategories(data).then(res => {
      return res.data
    })
  },
  creatNews (ctx, data) {
    return fetch.creatNews(data).then(res => {
      return res.data
    })
  },
  newsDetail (ctx, id) {
    return fetch.newsDetail(id).then(res => {
      let result = informationData.newsDetail(res.data)
      return result
    })
  },
  saveAndPublishNews (ctx, data) {
    return fetch.saveAndPublishNews(data).then(res => {
      return res.data
    })
  },
  publishNews (ctx, id) {
    return fetch.publishNews(id).then(res => {
      return res.data
    })
  },
  disabledNews (ctx, id) {
    return fetch.disabledNews(id).then(res => {
      return res.data
    })
  },
  editNews (ctx, data) {
    return fetch.editNews(data).then(res => {
      return res.data
    })
  },
  deleteNews (ctx, id) {
    return fetch.deleteNews(id).then(res => {
      return res.data
    })
  },
  enumerationByExample (ctx, data) {
    return fetch.enumerationByExample(data).then(res => {
      return getTotalNumber(res)
    })
  },
  categoriesWithNewsCount (ctx, data) {
    return fetch.categoriesWithNewsCount(data).then(res => {
      let result = getTotalNumber(res)
      result.data = informationData.categoriesWithNewsCount(result.data)
      return result
    })
  },
  createEnumeration (ctx, data) {
    return fetch.createEnumeration(data).then(res => {
      return res.data
    })
  },
  enumerationDetial (ctx, id) {
    return fetch.enumerationDetial(id).then(res => {
      return res.data
    })
  },
  // 获取消息列表
  getNoticeList (ctx, data) {
    return fetch.getNoticeList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = informationData.getNoticeList(result.data)
      return result
    })
  },
  // 发布消息
  publishNotice (ctx, data) {
    return fetch.publishNotice(data).then(res => {
      return res.data
    })
  },
  noticeDetail (ctx, data) {
    return fetch.noticeDetail(data).then(res => {
      let result = informationData.noticeDetail(res.data)
      return result
    })
  }
}
